export const REFRESH_INTERVAL_MS = 0;
export const STALE_TIME = 1000 * 60 * 5;